/*
  会员积分页 - 会員限定特典 等级对比表
  第一列是 sticky 的，它的圆角把单元格四角切掉了，滑到它下面的等级列
  会从这几个缺口里透出来。横向一开始滚动就把第一列改成直角，让它完整
  挡住下层；滑回最左边再恢复圆角，静止时的卡片感不变。
*/
class MembershipPointsTiers extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-scroller]');
    if (!this.scroller) return;

    this.onScroll = this.onScroll.bind(this);
    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

    // 浏览器会还原上次的滚动位置，初始状态也要对
    this.syncState();
  }

  disconnectedCallback() {
    if (this.scroller) this.scroller.removeEventListener('scroll', this.onScroll);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  onScroll() {
    // 滚动事件触发很密，合并到一帧里只改一次 class
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.syncState();
    });
  }

  syncState() {
    // 惯性回弹时 scrollLeft 会有零点几像素的残留，留 1px 容差
    this.scroller.classList.toggle('is-scrolled', this.scroller.scrollLeft > 1);
  }
}

if (!customElements.get('membership-points-tiers')) {
  customElements.define('membership-points-tiers', MembershipPointsTiers);
}
